package one.healthium.data.user.dto

import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class PushTokenDto(
    @SerialName("token") val token: String,
    @SerialName("platform") val platform: String,
    @SerialName("installation_id") val installationId: String,
    @SerialName("updated_at") val updatedAt: Timestamp,
)
